@let configStatus = config();
@let currentStatus = configStatus.status;

@if (currentStatus === opportunityStatuses.Unqualified || currentStatus === opportunityStatuses.Disqualified) {
    <button class="resetStyles group-btn" (click)="onDisqualifyToggleClick($event)">
        <span>
            {{ currentStatus === opportunityStatuses.Unqualified ? 'Disqualified Lead' : 'Revert to Unqualified' }}
        </span>
    </button>
}

@if (configStatus.showManualStatusOption) {
    <button class="resetStyles group-btn" (click)="onManualStatusClick($event)">
        <span>
            {{ configStatus.hasManualStatus ? 'Edit Manual status' : 'Set Manual Status' }}
        </span>
    </button>
}
